import { useState } from 'react';
import { useFormValidated } from '../common/FormValidationContext';
import { Form } from 'react-bootstrap';

const YesNoRadioFieldset = ({
  name,
  legend,
  value,
  onChange,
  disabled = false,
  required = false,
  errorMessage = 'Please select Yes or No.',
}) => {
  const validated = useFormValidated();
  const [touched, setTouched] = useState(false);

  const isInvalid = required && (touched || validated) && !value;

  const handleChange = (e) => {
    onChange(e.target.value);
    setTouched(true);
  };

  const handleBlur = () => {
    setTouched(true);
  };

  return (
    <Form.Group as="fieldset">
      <Form.Label as="legend">
        <h4 className={required ? 'required-field' : undefined}>
          {legend}
        </h4>
      </Form.Label>

      <div className="radio-group" onBlur={handleBlur}>
        <Form.Check
          type="radio"
          name={name}
          id={`${name}-yes`}
          label="Yes"
          value="Yes"
          checked={value === 'Yes'}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          isInvalid={isInvalid && validated}
        />

        <Form.Check
          type="radio"
          name={name}
          id={`${name}-no`}
          label="No"
          value="No"
          checked={value === 'No'}
          onChange={handleChange}
          disabled={disabled}
          isInvalid={isInvalid && validated}
        />
      </div>

      <Form.Control.Feedback
        type="invalid"
        className={isInvalid && validated ? 'd-block' : undefined}
      >
        {errorMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default YesNoRadioFieldset;